export const SAC_PHONE_NUMBER = '3003 0101'
export const CALLCENTER_PHONE_NUMBER = '0800 722 2291'
